/**
 * Mobile App Footer - JavaScript
 * clumes.com - Shopify Theme
 * 
 * Handles:
 * - Active state management
 * - Menu drawer open/close
 * - Wishlist integration (SE Wishlist Engine)
 * - Cart counter updates
 * - Mega menu accordion logic
 */

(function() {
  'use strict';

  // ==========================================================================
  // ACTIVE STATE MANAGEMENT
  // ==========================================================================
  
  function setActiveItem() {
    var currentPath = window.location.pathname;
    var footerItems = document.querySelectorAll('.mobile-app-footer__item');
    
    footerItems.forEach(function(item) {
      item.classList.remove('active');
      var href = item.getAttribute('href');
      
      if (!href) return;
      
      if (href === theme.routes.home && currentPath === theme.routes.home) {
        item.classList.add('active');
      } else if (href !== theme.routes.home && currentPath.startsWith(href)) {
        item.classList.add('active');
      }
    });
  }

  // ==========================================================================
  // MENU DRAWER MANAGEMENT
  // ==========================================================================
  
  var shopBtn = document.getElementById('mobileShopBtn');
  var menuOverlay = document.getElementById('mobileMenuOverlay');
  var closeBtn = document.getElementById('closeMobileMenu');

  function openMenu() {
    if (menuOverlay) {
      menuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMenu() {
    if (menuOverlay) {
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (shopBtn) {
    shopBtn.addEventListener('click', openMenu);
  }

  // Header Shop Button: gleiche Funktion wie Footer Shop Button
  var headerShopBtn = document.getElementById('headerShopBtn');
  if (headerShopBtn) {
    headerShopBtn.addEventListener('click', openMenu);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  if (menuOverlay) {
    menuOverlay.addEventListener('click', function(e) {
      if (e.target === menuOverlay) {
        closeMenu();
      }
    });
  }

  // ==========================================================================
  // WISHLIST INTEGRATION (SE Wishlist Engine)
  // ==========================================================================
  
  var wishlistBtn = document.getElementById('mobileWishlistBtn');
  
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function() {
      window.location.href = '/apps/wishlist';
    });
  }

  function updateWishlistCount() {
    var wishlistBadge = document.getElementById('wishlistCountBadge');
    if (!wishlistBadge) return;
    
    var possibleCounters = [
      document.querySelector('.wishlist-h-count'),
      document.querySelector('.wishlist-total-count'),
      document.querySelector('[class*="wishlist"][class*="count"]'),
      document.querySelector('.se-wishlist-count'),
      document.querySelector('[data-wishlist-count]')
    ];
    
    var count = 0;
    
    for (var i = 0; i < possibleCounters.length; i++) {
      var counter = possibleCounters[i];
      if (counter && counter.textContent) {
        var parsed = parseInt(counter.textContent.trim());
        if (!isNaN(parsed) && parsed >= 0) {
          count = parsed;
          break;
        }
      }
    }
    
    wishlistBadge.textContent = count;
    wishlistBadge.style.display = count > 0 ? 'flex' : 'none';
  }

  // Initial wishlist count updates (gestaffelt für Zuverlässigkeit)
  setTimeout(updateWishlistCount, 300);
  setTimeout(updateWishlistCount, 800);
  setTimeout(updateWishlistCount, 1500);
  
  document.addEventListener('wishlist:updated', updateWishlistCount);
  document.addEventListener('se:wishlist:updated', updateWishlistCount);
  document.addEventListener('DOMContentLoaded', updateWishlistCount);
  
  function observeWishlistCounter() {
    var headerCounter = document.querySelector('.wishlist-h-count') || 
                        document.querySelector('.wishlist-total-count');
    
    if (headerCounter && window.MutationObserver) {
      var observer = new MutationObserver(updateWishlistCount);
      observer.observe(headerCounter, { 
        childList: true, 
        characterData: true,
        subtree: true 
      });
    }
  }
  
  setTimeout(observeWishlistCounter, 1000);
  
  // Polling nur wenn Badge im DOM (= Footer sichtbar)
  if (document.getElementById('wishlistCountBadge')) {
    setInterval(updateWishlistCount, 5000);
  }

  // ==========================================================================
  // CART COUNTER UPDATES
  // ==========================================================================
  
  function updateCartCount() {
    var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart)
      ? theme.routes.cart
      : '/cart.js';
    fetch(cartUrl)
      .then(function(response) { return response.json(); })
      .then(function(data) {
        var badge = document.getElementById('cartCountBadge');
        if (badge) badge.textContent = data.item_count;
      })
      .catch(function(error) { console.error('Cart count update error:', error); });
  }

  // Listen to cart events
  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('cart:refresh', updateCartCount);
  
  if (typeof theme !== 'undefined') {
    document.addEventListener('theme:cart:change', updateCartCount);
  }

  // ==========================================================================
  // PUSH NAVIGATION LOGIC (3 Ebenen, Stack-basiert)
  // ==========================================================================

  function initPushNav() {
    var backBtn = document.getElementById('pushNavBack');
    var titleEl = document.getElementById('pushNavTitle');
    var header = document.querySelector('.mobile-menu-drawer__header');

    // Stack: hält Verlauf der geöffneten Panels
    // [{panel: Element, title: String}, ...]
    var panelStack = [];

    var searchEl = document.getElementById('pushNavSearch');

    function setHeaderMode(isSub) {
      // isSub=true: zeige Titel + Back, verstecke Suche
      // isSub=false: zeige Suche, verstecke Titel
      if (searchEl) searchEl.style.display = isSub ? 'none' : '';
      if (titleEl) titleEl.style.display = isSub ? 'block' : 'none';
      if (backBtn) backBtn.style.display = isSub ? 'block' : 'none';
      if (header) {
        if (isSub) header.classList.add('mobile-menu-drawer__header--sub');
        else header.classList.remove('mobile-menu-drawer__header--sub');
      }
    }

    // Init: Suche sichtbar, Titel versteckt
    setHeaderMode(false);

    function openPanel(targetId) {
      var targetPanel = document.getElementById(targetId);
      if (!targetPanel) return;

      // Resultate schliessen wenn offen
      var resultsBox = document.getElementById('pushNavSearchResults');
      if (resultsBox) {
        resultsBox.classList.remove('push-nav__search-results--visible');
        resultsBox.innerHTML = '';
      }

      // Aktuell sichtbares Panel nach links schieben
      var currentVisible = panelStack.length > 0
        ? panelStack[panelStack.length - 1].panel
        : document.getElementById('pushNavRoot');

      currentVisible.classList.remove('push-nav__panel--active');
      currentVisible.classList.add('push-nav__panel--slide-out');

      // Neues Panel von rechts reinschieben
      targetPanel.classList.add('push-nav__panel--active');
      targetPanel.scrollTop = 0;

      // Stack aktualisieren
      var panelTitle = targetPanel.getAttribute('data-panel-title') || '';
      panelStack.push({ panel: targetPanel, title: panelTitle });

      // Header: Suche raus, Titel rein
      if (titleEl) titleEl.textContent = panelTitle;
      setHeaderMode(true);
    }

    function goBack() {
      if (panelStack.length === 0) return;

      // Aktuelles Panel rausschieben
      var current = panelStack.pop();
      current.panel.classList.remove('push-nav__panel--active');
      setTimeout(function() {
        current.panel.classList.remove('push-nav__panel--slide-out');
      }, 300);

      if (panelStack.length > 0) {
        // Vorheriges Sub-Panel zurückschieben
        var prev = panelStack[panelStack.length - 1];
        prev.panel.classList.remove('push-nav__panel--slide-out');
        prev.panel.classList.add('push-nav__panel--active');
        if (titleEl) titleEl.textContent = prev.title;
      } else {
        // Zurück zu Root: Suche wieder anzeigen
        var rootPanel = document.getElementById('pushNavRoot');
        rootPanel.classList.remove('push-nav__panel--slide-out');
        rootPanel.classList.add('push-nav__panel--active');
        setHeaderMode(false);
      }
    }

    // Event Delegation: alle [data-push-open] Buttons
    document.getElementById('pushNav').addEventListener('click', function(e) {
      var btn = e.target.closest('[data-push-open]');
      if (btn) {
        openPanel(btn.getAttribute('data-push-open'));
      }
    });

    // Back Button
    if (backBtn) {
      backBtn.addEventListener('click', goBack);
    }

    // resetPushNav nutzt panelStack – als Closure speichern
    window._pushNavStack = panelStack;
  }

  initPushNav();

  // ==========================================================================
  // LIVE SEARCH
  // ==========================================================================

  function initLiveSearch() {
    var input = document.getElementById('pushNavSearchInput');
    var resultsBox = document.getElementById('pushNavSearchResults');
    var searchForm = input ? input.closest('form') : null;

    if (!input || !resultsBox) return;

    var debounceTimer = null;
    var currentQuery = '';

    // Preise formatieren: CHF 79.- oder CHF 60.90
    // /search/suggest.json gibt Preise bereits in Franken zurück (z.B. 39.0)
    function formatPrice(franken) {
      var num = parseFloat(franken);
      var formatted = num % 1 === 0
        ? Math.floor(num) + '.-'
        : num.toFixed(2);
      return 'CHF ' + formatted;
    }

    function showLoading() {
      resultsBox.innerHTML = '<div class="push-nav__results-loading"><div class="push-nav__results-spinner"></div></div>';
      resultsBox.classList.add('push-nav__search-results--visible');
    }

    function hideResults() {
      resultsBox.classList.remove('push-nav__search-results--visible');
      resultsBox.innerHTML = '';
    }

    function renderResults(data, query) {
      var products = data.resources && data.resources.results && data.resources.results.products
        ? data.resources.results.products
        : [];
      var collections = data.resources && data.resources.results && data.resources.results.collections
        ? data.resources.results.collections
        : [];

      if (products.length === 0 && collections.length === 0) {
        resultsBox.innerHTML = '<div class="push-nav__results-empty">Keine Resultate für «' + query + '»</div>';
        resultsBox.classList.add('push-nav__search-results--visible');
        return;
      }

      var html = '';

      // Produkte
      if (products.length > 0) {
        html += '<div class="push-nav__results-group">';
        html += '<span class="push-nav__results-label">Produkte</span>';

        products.slice(0, 4).forEach(function(product) {
          var imgSrc = product.featured_image && product.featured_image.url
            ? product.featured_image.url + '&width=100'
            : '';
          var price = product.price ? formatPrice(product.price) : '';

          html += '<a href="' + product.url + '" class="push-nav__result-product">';
          if (imgSrc) {
            html += '<img src="' + imgSrc + '" alt="' + product.title + '" class="push-nav__result-img" width="44" height="44" loading="lazy">';
          } else {
            html += '<div class="push-nav__result-img"></div>';
          }
          html += '<div class="push-nav__result-info">';
          html += '<div class="push-nav__result-title">' + product.title + '</div>';
          if (price) html += '<div class="push-nav__result-price">' + price + '</div>';
          html += '</div></a>';
        });

        html += '</div>';
      }

      // Collections
      if (collections.length > 0) {
        if (products.length > 0) html += '<div class="push-nav__results-divider"></div>';
        html += '<div class="push-nav__results-group">';
        html += '<span class="push-nav__results-label">Kategorien</span>';

        collections.slice(0, 3).forEach(function(col) {
          html += '<a href="' + col.url + '" class="push-nav__result-link">';
          html += col.title;
          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>';
          html += '</a>';
        });

        html += '</div>';
      }

      // "Alle Resultate" Link
      html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="push-nav__results-all">Alle Resultate für «' + query + '» →</a>';

      resultsBox.innerHTML = html;
      resultsBox.classList.add('push-nav__search-results--visible');
    }

    function fetchResults(query) {
      currentQuery = query;

      var url = '/search/suggest.json?q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection'
        + '&resources[limit]=5'
        + '&resources[options][unavailable_products]=last';

      fetch(url)
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (currentQuery === query) {
            renderResults(data, query);
          }
        })
        .catch(function() {
          hideResults();
        });
    }

    input.addEventListener('input', function() {
      var query = input.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        hideResults();
        return;
      }

      showLoading();

      debounceTimer = setTimeout(function() {
        fetchResults(query);
      }, 250);
    });

    // Klick ausserhalb → Resultate schliessen
    document.addEventListener('click', function(e) {
      if (!e.target.closest('#pushNavSearch')) {
        hideResults();
      }
    });

    // Drawer schliesst → Suche zurücksetzen
    var _origReset = window._pushNavReset;
    window._pushNavReset = function() {
      hideResults();
      input.value = '';
      if (_origReset) _origReset();
    };
  }

  initLiveSearch();


  // Reset push nav state when drawer closes
  function resetPushNav() {
    document.querySelectorAll('.push-nav__panel').forEach(function(panel) {
      panel.classList.remove('push-nav__panel--active', 'push-nav__panel--slide-out');
    });

    var rootPanel = document.getElementById('pushNavRoot');
    if (rootPanel) rootPanel.classList.add('push-nav__panel--active');

    // Header zurück auf Suche
    var searchElR = document.getElementById('pushNavSearch');
    var titleElR = document.getElementById('pushNavTitle');
    var backBtnR = document.getElementById('pushNavBack');
    var headerR = document.querySelector('.mobile-menu-drawer__header');
    if (searchElR) searchElR.style.display = '';
    if (titleElR) { titleElR.style.display = 'none'; titleElR.textContent = ''; }
    if (backBtnR) backBtnR.style.display = 'none';
    if (headerR) headerR.classList.remove('mobile-menu-drawer__header--sub');

    // Stack leeren
    if (window._pushNavStack) window._pushNavStack.length = 0;

    // Suche zurücksetzen
    var searchInput = document.getElementById('pushNavSearchInput');
    var searchResults = document.getElementById('pushNavSearchResults');
    if (searchInput) searchInput.value = '';
    if (searchResults) {
      searchResults.classList.remove('push-nav__search-results--visible');
      searchResults.innerHTML = '';
    }

    // Shop-Button explizit deaktivieren (hat kein href, wird von setActiveItem ignoriert)
    var shopBtn = document.getElementById('mobileShopBtn');
    if (shopBtn) shopBtn.classList.remove('active');

    // Alle anderen Items URL-basiert neu setzen
    setActiveItem();
  }

  // Hook into closeMenu to reset state
  var _origCloseMenu = closeMenu;
  closeMenu = function() {
    _origCloseMenu();
    setTimeout(resetPushNav, 350);
  };

  // ==========================================================================
  // FOOTER STATE MANAGEMENT (zentral)
  // ==========================================================================

  var footerState = { cartOpen: false, atcActive: false };

  function updateFooterVisibility() {
    var footer = document.querySelector('.mobile-app-footer');
    if (!footer) return;
    if (footerState.cartOpen || footerState.atcActive) {
      footer.classList.add('footer--hidden');
    } else {
      footer.classList.remove('footer--hidden');
    }
  }

  // ==========================================================================
  // CART DRAWER VISIBILITY
  // ==========================================================================

  function initCartDrawerVisibility() {
    var cartDrawer = document.getElementById('CartDrawer');
    var footer = document.querySelector('.mobile-app-footer');
    
    if (!cartDrawer || !footer || !window.MutationObserver) return;
    
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          footerState.cartOpen = cartDrawer.classList.contains('drawer--is-open');
          updateFooterVisibility();
        }
      });
    });
    
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // ==========================================================================
  // PRODUKTSEITE: Footer ↔ Sticky ATC Koordination
  // ==========================================================================

  /**
   * Beobachtet #sticky-atc-mobile auf die Klasse "is-visible".
   * Unser handleScroll() in product-sticky-atc.liquid setzt/entfernt diese Klasse.
   * Wenn is-visible → Footer weg + body.footer-scrolled (für CSS-Positionierung).
   * Wenn nicht mehr is-visible → Footer zurück.
   */
  function initProductPageScroll() {
    if (!document.body.classList.contains('template-product')) return;

    var stickyAtc = document.getElementById('sticky-atc-mobile');
    if (!stickyAtc || !window.MutationObserver) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          var isActive = stickyAtc.classList.contains('is-visible');
          footerState.atcActive = isActive;
          if (isActive) {
            document.body.classList.add('footer-scrolled');
          } else {
            document.body.classList.remove('footer-scrolled');
          }
          updateFooterVisibility();
        }
      });
    });

    observer.observe(stickyAtc, { attributes: true, attributeFilter: ['class'] });
  }

  initProductPageScroll();

  // ==========================================================================
  // PRODUKTSEITE: Wishlist-Button in Sticky ATC klonen
  // ==========================================================================

  /**
   * Klont den bestehenden .wishlist-engine Button aus dem nativen ATC-Bereich
   * und fügt ihn rechts neben dem Sticky ATC Button ein.
   * SE Wishlist Engine behält so die volle Kontrolle über Logik & State.
   *
   * Timing: SE Wishlist Engine initialisiert sich kurz nach DOM-ready,
   * daher mit kurzem Delay ausführen.
   */
  function initStickyWishlist() {
    if (!document.body.classList.contains('template-product')) return;

    function cloneWishlistButton() {
      var stickyWrapper = document.querySelector('.sticky-atc-mobile__wrapper');
      if (!stickyWrapper) return;

      // Bereits eingefügt? Nicht doppelt klonen.
      if (stickyWrapper.querySelector('.sticky-atc-mobile__wishlist')) return;

      // Originalbutton aus nativem ATC-Bereich holen
      var originalWishlist = document.querySelector('.product-action-wrapper .wishlist-engine');
      if (!originalWishlist) return;

      // Wrapper-Div erstellen
      var wishlistWrapper = document.createElement('div');
      wishlistWrapper.className = 'sticky-atc-mobile__wishlist';

      // Wishlist-Engine klonen (deep clone = true → inkl. aller Kinder & Attribute)
      var clonedWishlist = originalWishlist.cloneNode(true);
      wishlistWrapper.appendChild(clonedWishlist);

      // Rechts vom ATC-Button einfügen
      stickyWrapper.appendChild(wishlistWrapper);

      // SE Wishlist Engine neu auf geklonten Button initialisieren
      // Die Engine hört auf data-Attribute – ein simples Click-Event reicht
      // um die API zu triggern (Engine nutzt Event Delegation auf document)
      clonedWishlist.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // Original-Button klicken → SE Engine verarbeitet den echten Button
        var origBtn = originalWishlist.querySelector('.wishlist-engine-button');
        if (origBtn) origBtn.click();
        // State auf Klon synchronisieren
        setTimeout(function() {
          var origIcon = originalWishlist.querySelector('.wishlist-icon');
          var cloneIcon = clonedWishlist.querySelector('.wishlist-icon');
          if (origIcon && cloneIcon) {
            cloneIcon.innerHTML = origIcon.innerHTML;
          }
        }, 100);
      });

      // MutationObserver: Original-State-Änderungen auf Klon spiegeln
      // (z.B. wenn Herz gefüllt wird nach Wishlist-Add)
      var origBtn = originalWishlist.querySelector('.wishlist-engine-button');
      if (origBtn && window.MutationObserver) {
        var iconObserver = new MutationObserver(function() {
          var origIcon = originalWishlist.querySelector('.wishlist-icon');
          var cloneIcon = clonedWishlist.querySelector('.wishlist-icon');
          if (origIcon && cloneIcon) {
            cloneIcon.innerHTML = origIcon.innerHTML;
          }
        });
        iconObserver.observe(origBtn, { childList: true, subtree: true, characterData: true });
      }
    }

    // Gestaffelt versuchen – SE Wishlist Engine braucht etwas Zeit
    setTimeout(cloneWishlistButton, 500);
    setTimeout(cloneWishlistButton, 1500);
  }

  initStickyWishlist();

  // ==========================================================
  // PRODUKTSEITE: Stoq "E-Mail bei Verfügbarkeit" im Sticky
  // ==========================================================

  /**
   * Zwei Buttons direkt im HTML (#sticky-add-to-cart-mobile + #sticky-notify-btn).
   * syncButtons() toggelt basierend auf originalBtn.disabled (nativer Button).
   * Klick auf Notify → actionWrapper kurz visible → origCover.click() → hidden.
   */
  function initStickyNotify() {
    if (!document.body.classList.contains('template-product')) return;
    if (window.innerWidth > 767) return;

    var stickyAtcBtn = document.getElementById('sticky-add-to-cart-mobile');
    var stickyNotifyBtn = document.getElementById('sticky-notify-btn');
    if (!stickyAtcBtn || !stickyNotifyBtn) return;

    // Klick auf Notify Button → Original Cover kurz sichtbar machen und klicken
    stickyNotifyBtn.addEventListener('click', function() {
      var actionWrapper = document.querySelector('.product-action-wrapper');
      var origCover = document.querySelector('.restock-rocket-button-cover');
      if (!origCover || !actionWrapper) return;
      actionWrapper.style.visibility = 'visible';
      origCover.click();
      setTimeout(function() {
        actionWrapper.style.visibility = 'hidden';
      }, 300);
    });

    // ATC vs Notify: toggeln basierend auf nativem Button (Impulse kontrolliert disabled)
    function syncButtons() {
      var originalBtn = document.querySelector('[data-add-to-cart]');
      var isAvailable = originalBtn ? !originalBtn.disabled : true;
      stickyAtcBtn.style.display = isAvailable ? '' : 'none';
      stickyNotifyBtn.style.display = isAvailable ? 'none' : '';
    }

    setTimeout(syncButtons, 300);

    // Nativen Button beobachten – nicht den Sticky Button
    var originalBtn = document.querySelector('[data-add-to-cart]');
    if (originalBtn && window.MutationObserver) {
      new MutationObserver(function() {
        setTimeout(syncButtons, 150);
      }).observe(originalBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  initStickyNotify();

  // ==========================================================================
  // INITIALIZATION
  // ==========================================================================
  
  // Set active item on load
  setActiveItem();
  
  // Tap feedback: clicking footer items updates active state visually
  document.querySelectorAll('.mobile-app-footer__item').forEach(function(item) {
    item.addEventListener('click', function() {
      // Only update active if it's a non-href button (like Shop)
      // For links, setActiveItem() handles it via URL
      if (!item.getAttribute('href')) {
        document.querySelectorAll('.mobile-app-footer__item').forEach(function(i) {
          i.classList.remove('active');
        });
        item.classList.add('active');
      }
    });
  });
  
  // Cart Drawer Visibility
  initCartDrawerVisibility();
  
  // Update on navigation (for SPA-like navigation)
  window.addEventListener('popstate', setActiveItem);

})();
